export const translations = {
  es: {
    login_title: "Iniciar Sesion",
    student: "Estudiante",
    teacher: "Docente",
    admin: "Administrador",
    username: "Usuario",
    password: "Contrasena",
    login_button: "Ingresar",
    forgot_password: "Olvido su contrasena?",
    admin_login: "Acceso Administrador",
    slogan1: "Aprende hoy, lidera manana",
    slogan2: "Activa tu mente. Habla ingles",
    my_classes: "Mis Clases",
    create_class: "Crear Clase",
    manage_users: "Gestionar Usuarios",
    class_name: "Nombre de la clase",
    class_level: "Nivel",
    class_description: "Descripcion",
    members: "Miembros",
    lessons: "Lecciones",
    tasks: "Tareas",
    corrections: "Correcciones",
    evaluations: "Evaluaciones",
    reinforcement: "Refuerzo Academico",
    comments: "Comentarios",
    voice_recorder: "Grabadora de voz",
    tutorials: "Tutoriales",
    library: "Biblioteca",
    analytics: "Estadísticas",
    upload: "Subir",
    download: "Descargar",
    submit: "Entregar",
    submitted: "Entregado",
    review: "Revisar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    create: "Crear",
    close: "Cerrar",
    add: "Agregar",
    actions: "Acciones",
    send: "Enviar",
    upload_activity: "Subir actividades",
    download_lesson: "Descargar leccion",
    submit_activity: "Entregar actividad",
    review_submissions: "Revisar trabajos enviados",
    upload_task: "Subir tarea",
    download_task: "Descargar tarea asignada",
    submit_task: "Entregar tarea",
    review_task: "Revisar tarea del estudiante",
    upload_correction: "Subir correccion",
    download_correction: "Descargar correccion",
    submit_correction: "Entregar correccion",
    review_correction: "Revisar correccion del estudiante",
    evaluation_link: "Enlace a plataforma de evaluacion",
    evaluation_result: "Resultado de la evaluacion",
    reinforcement_activity: "Actividad de refuerzo",
    download_reinforcement: "Descargar refuerzo",
    submit_reinforcement: "Entregar refuerzo",
    reinforcement_completed: "Refuerzo realizado en plataforma",
    profile: "Perfil",
    settings: "Configuracion",
    personal_data: "Datos Personales",
    change_password: "Cambiar Contrasena",
    current_password: "Contrasena actual",
    new_password: "Nueva contrasena",
    confirm_password: "Confirmar contrasena",
    profile_image: "Foto de Perfil",
    first_name: "Nombre",
    last_name: "Apellido",
    email: "Correo Electronico",
    email_verified: "Verificado",
    email_not_verified: "No verificado",
    create_user: "Crear Usuario",
    user_role: "Rol",
    invitation_link: "Enlace de Invitacion",
    generate_invite: "Generar Invitacion",
    logout: "Cerrar Sesion",
    language: "Idioma",
    spanish: "Espanol",
    english: "Ingles",
    title: "Titulo",
    description: "Descripcion",
    folder: "Carpeta/Unidad",
    attach_file: "Adjuntar archivo",
    attach_link: "Adjuntar enlace",
    no_items: "No hay elementos",
    loading: "Cargando...",
    success: "Exito",
    error: "Error",
    password_changed: "Contrasena cambiada exitosamente",
    profile_updated: "Perfil actualizado",
    select_language: "Selecciona tu idioma",
    add_students: "Agregar Estudiantes",
    score: "Puntuacion",
    write_comment: "Escribe un comentario...",
    send: "Enviar",
    reply: "Responder",
    file_preview: "Vista previa",
    validated: "Validado",
    welcome: "Bienvenido",
    back_to_dashboard: "Volver al panel",
    no_classes: "No tienes clases aun",
    enter_email: "Ingresa tu correo electronico",
    reset_password: "Restablecer contrasena",
    video_lesson: "Video de leccion",
    upload_video: "Subir video",
    lesson_reference: "Referencia de la leccion",
    all_units: "Todas las unidades",
    new_folder: "Nueva carpeta",
    enter_link: "Pegar enlace",
    class_settings: "Configuracion de clase",
    student_list: "Lista de estudiantes",
    search_students: "Buscar estudiantes",
    confirm_delete: "Confirmar eliminacion",
    level_beginner: "Principiante",
    level_intermediate: "Intermedio",
    level_advanced: "Avanzado",
    back: "Volver",
    invite_students: "Invitar Estudiantes",
    copy_link: "Copiar enlace",
    link_copied: "Enlace copiado",
    badges: "Insignias",
    xp_points: "Puntos XP",
    level: "Nivel",
    badge_earned: "Insignia obtenida!",
    my_progress: "Mi Progreso",
    student_progress: "Progreso del Estudiante",
    xp_to_next: "XP para siguiente nivel",
    no_badges_yet: "Aun no tienes insignias",
    keep_going: "Sigue asi!",
    new_badge: "Nueva Insignia!",
    congratulations: "Felicitaciones!",
    cancel_submission: "Anular entrega",
    resubmit: "Volver a enviar",
    resubmitted: "Reenviado",
    submission_cancelled: "Entrega anulada. Puedes volver a enviar.",
    schedule_publication: "Programar publicacion",
    scheduled_for: "Programado para",
    publish_now: "Publicar ahora",
    publish_later: "Programar para despues",
    scheduled: "Programado",
    edit_schedule: "Editar programacion",
    schedule_updated: "Programacion actualizada",
    content_scheduled: "Contenido programado correctamente",
    select_date_time: "Seleccionar fecha y hora",
  },
  en: {
    login_title: "Sign In",
    student: "Student",
    teacher: "Teacher",
    admin: "Administrator",
    username: "Username",
    password: "Password",
    login_button: "Sign In",
    forgot_password: "Forgot your password?",
    admin_login: "Admin Access",
    slogan1: "Learn today, lead tomorrow",
    slogan2: "Activate your mind. Speak English",
    my_classes: "My Classes",
    create_class: "Create Class",
    manage_users: "Manage Users",
    class_name: "Class Name",
    class_level: "Level",
    class_description: "Description",
    members: "Members",
    lessons: "Lessons",
    tasks: "Tasks",
    corrections: "Corrections",
    evaluations: "Evaluations",
    reinforcement: "Academic Reinforcement",
    comments: "Comments",
    voice_recorder: "Voice Recorder",
    tutorials: "Tutorials",
    library: "Library",
    analytics: "Analytics",
    upload: "Upload",
    download: "Download",
    submit: "Submit",
    submitted: "Submitted",
    review: "Review",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    close: "Close",
    actions: "Actions",
    add: "Add",
    send: "Send",
    upload_activity: "Upload Activities",
    download_lesson: "Download Lesson",
    submit_activity: "Submit Activity",
    review_submissions: "Review Submitted Work",
    upload_task: "Upload Task",
    download_task: "Download Assigned Task",
    submit_task: "Submit Task",
    review_task: "Review Student's Task",
    upload_correction: "Upload Correction",
    download_correction: "Download Correction",
    submit_correction: "Submit Correction",
    review_correction: "Review Student's Correction",
    evaluation_link: "Evaluation Platform Link",
    evaluation_result: "Evaluation Result",
    reinforcement_activity: "Reinforcement Activity",
    download_reinforcement: "Download Reinforcement",
    submit_reinforcement: "Submit Reinforcement",
    reinforcement_completed: "Reinforcement completed on platform",
    profile: "Profile",
    settings: "Settings",
    personal_data: "Personal Data",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    profile_image: "Profile Photo",
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    email_verified: "Verified",
    email_not_verified: "Not verified",
    create_user: "Create User",
    user_role: "Role",
    invitation_link: "Invitation Link",
    generate_invite: "Generate Invitation",
    logout: "Sign Out",
    language: "Language",
    spanish: "Spanish",
    english: "English",
    title: "Title",
    description: "Description",
    folder: "Folder/Unit",
    attach_file: "Attach file",
    attach_link: "Attach link",
    no_items: "No items",
    loading: "Loading...",
    success: "Success",
    error: "Error",
    password_changed: "Password changed successfully",
    profile_updated: "Profile updated",
    select_language: "Select your language",
    add_students: "Add Students",
    score: "Score",
    write_comment: "Write a comment...",
    send: "Send",
    reply: "Reply",
    file_preview: "Preview",
    validated: "Validated",
    welcome: "Welcome",
    back_to_dashboard: "Back to dashboard",
    no_classes: "You don't have any classes yet",
    enter_email: "Enter your email",
    reset_password: "Reset password",
    video_lesson: "Video lesson",
    upload_video: "Upload video",
    lesson_reference: "Lesson reference",
    all_units: "All units",
    new_folder: "New folder",
    enter_link: "Paste link",
    class_settings: "Class settings",
    student_list: "Student list",
    search_students: "Search students",
    confirm_delete: "Confirm delete",
    level_beginner: "Beginner",
    level_intermediate: "Intermediate",
    level_advanced: "Advanced",
    back: "Back",
    invite_students: "Invite Students",
    copy_link: "Copy link",
    link_copied: "Link copied",
    badges: "Badges",
    xp_points: "XP Points",
    level: "Level",
    badge_earned: "Badge earned!",
    my_progress: "My Progress",
    student_progress: "Student Progress",
    xp_to_next: "XP to next level",
    no_badges_yet: "No badges yet",
    keep_going: "Keep going!",
    new_badge: "New Badge!",
    congratulations: "Congratulations!",
    cancel_submission: "Cancel submission",
    resubmit: "Resubmit",
    resubmitted: "Resubmitted",
    submission_cancelled: "Submission cancelled. You can resubmit.",
    schedule_publication: "Schedule publication",
    scheduled_for: "Scheduled for",
    publish_now: "Publish now",
    publish_later: "Schedule for later",
    scheduled: "Scheduled",
    edit_schedule: "Edit schedule",
    schedule_updated: "Schedule updated",
    content_scheduled: "Content scheduled successfully",
    select_date_time: "Select date and time",
  }
};
